<template>
  <div class="user-feedback-container">
    <adminTable :hideSeachButton="true" :tableLoading="tableLoading" :totalList="totalList" v-model:page="page"
      v-model:limit="limit" v-model:searchForm="searchForm" :tableData="tableData" @search="getList">
      <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="uid" label="用户ID" width="80" />
      <el-table-column prop="phone" label="手机号码" width="120" />
      <el-table-column prop="type" label="类型" width="100" />
      <el-table-column prop="title" label="标题" width="200" show-overflow-tooltip />
      <el-table-column prop="content" label="内容" width="300" show-overflow-tooltip>
        <template #default="scope">
          <div style="max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{ scope.row.content }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="图片" width="120">
        <template #default="scope">
          <span v-if="!scope.row.images || scope.row.images.length === 0">--</span>
          <el-image
            v-else
            style="width: 60px; height: 60px"
            :src="getImageUrl(scope.row.images[0])"
            :preview-src-list="scope.row.images.map(img => getImageUrl(img))"
            :preview-teleported="true"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="120">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 0" type="warning" size="small">待处理</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="primary" size="small">处理中</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="success" size="small">已完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="添加时间" width="180" />
      <el-table-column label="操作" width="160" fixed="right" v-if="currentUser.role == 0">
        <template #default="scope">
          <el-button type="primary" icon="Edit" size="small" v-permission
            @click="openEditDialog(scope.row)">处理</el-button>
          <el-button type="danger" icon="Delete" size="small" v-permission
            @click="deleteAction(scope.row)">删除</el-button>
        </template>
        </el-table-column>
      </template>
    </adminTable>

    <!-- Edit Dialog -->
    <el-dialog v-model="dialogVisible" title="处理反馈" width="500px">
      <el-form :model="editForm" label-width="80px">
        <el-form-item label="用户ID">
          <span>{{ editForm.uid }}</span>
        </el-form-item>
        <el-form-item label="标题">
          <span>{{ editForm.title }}</span>
        </el-form-item>
        <el-form-item label="内容">
          <div style="max-height: 100px; overflow-y: auto;">{{ editForm.content }}</div>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.status" placeholder="选择状态">
            <el-option label="待处理" :value="0" />
            <el-option label="处理中" :value="1" />
            <el-option label="已完成" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="回复">
          <el-input v-model="editForm.reply" type="textarea" :rows="3" placeholder="输入回复内容" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="submitLoading">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

onMounted(() => {
  getList();
});

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const { proxy } = getCurrentInstance();

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const searchForm = ref({});

// Edit dialog
const dialogVisible = ref(false);
const submitLoading = ref(false);
const editForm = ref({
  id: null,
  uid: '',
  title: '',
  content: '',
  status: 0,
  reply: ''
});

const openEditDialog = (row) => {
  editForm.value = {
    id: row.id,
    uid: row.uid,
    title: row.title,
    content: row.content,
    status: row.status,
    reply: row.reply || ''
  };
  dialogVisible.value = true;
};

const submitEdit = async () => {
  submitLoading.value = true;
  const res = await proxy.$http({
    method: "post",
    url: "/Feedback/updateFeedbackState",
    data: {
      id: editForm.value.id,
      status: editForm.value.status,
      reply: editForm.value.reply
    }
  });
  submitLoading.value = false;
  if (res.code == 0) {
    ElMessage({ type: "success", message: "处理成功" });
    dialogVisible.value = false;
    // Update local data
    const index = tableData.value.findIndex(item => item.id === editForm.value.id);
    if (index !== -1) {
      tableData.value[index].status = editForm.value.status;
      tableData.value[index].reply = editForm.value.reply;
    }
  } else {
    ElMessage({ type: "error", message: res.msg || "处理失败" });
  }
};

const getImageUrl = (img) => {
  if (!img) return "";
  img = img.trim();
  if (img.startsWith("http://") || img.startsWith("https://")) {
    return img;
  }
  if (img.startsWith("/")) {
    return proxy.IMG_BASE_URL + img;
  }
  return proxy.IMG_BASE_URL + "/" + img;
};

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/Feedback/getFeedbackLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "/Feedback/deleteFeedback?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
        ElMessage({ type: "success", message: "删除成功" });
      } else {
        ElMessage({ type: "error", message: res.msg });
      }
    })
    .catch(() => {
      ElMessage({ type: "info", message: "取消删除" });
    });
};
</script>

<style lang="less" scoped></style>
